module.exports = __webpack_public_path__ + "static/img/f-step3.be95a023.png";